import React from 'react'
import './know-before-you-code.css'
import { Button, Badge } from '@paypalcorp/pp-react'
import { DocumentCheckIcon } from '../layout/Icons/DocumentCheckIcon'
import { RunInPostman } from '../layout'

export interface KnowBeforeYouCodeCardProps {
  badge?: 'Optional' | 'Required'
  title: string
  listElements?: React.JSX.Element[]
  primaryType?: 'button' | 'postman'
  primaryLabel: string
  primaryLink?: string
  tertiaryLink?: string
  tertiaryLabel?: string
}

export const KnowBeforeYouCodeCard: React.FC<KnowBeforeYouCodeCardProps> = ({
  badge = 'Optional',
  title,
  listElements,
  primaryType,
  primaryLink,
  primaryLabel,
  tertiaryLink,
  tertiaryLabel,
  children,
}) => {
  return (
    <div className={`know_berofe_you_code_card`}>
      <div className="heading">
        <DocumentCheckIcon />
        <div>
          <Badge type={badge !== 'Required' ? 'neutral' : 'warning'}>
            {badge}
          </Badge>
        </div>
      </div>
      <div className={'content'}>
        {title && <p className="boldArchText">{title}</p>}
        {children ? children : <ul>{listElements}</ul>}
      </div>
      <div className="actions">
        {primaryType === 'postman' && (
          <RunInPostman text="" newArchetype zIndex="50000" />
        )}
        {primaryType === 'button' && (
          <Button as="a" href={primaryLink} role="button">
            {primaryLabel}
          </Button>
        )}
        {tertiaryLink && tertiaryLabel && (
          <a href={tertiaryLink} className="linkFormat">
            {tertiaryLabel}
          </a>
        )}
      </div>
    </div>
  )
}
